import { render, staticRenderFns } from "./PortalRegistrationMethodPanPms.vue?vue&type=template&id=bd574b5e&"
import script from "./PortalRegistrationMethodPanPms.vue?vue&type=script&lang=js&"
export * from "./PortalRegistrationMethodPanPms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports